import twttr from 'twitter-text'

export const calculateTwitterChars = (string) => {
    string = string || "";
    const tweet = twttr.parseTweet(string);
    return tweet.weightedLength;
}